// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3baFU","overflowing":"ReadFullNote_overflowing__3YTrW"};